export const authData = () => {
  const authData = localStorage.getItem("authData");
  if(authData){
    return JSON.parse(authData);
  }else{
    return null;
  }
}